upstack.directive('conversionScript', function () {
  return {
    restrict: 'E',
    template: ' ' +
      '<script type="text/javascript">' +
        '/* <![CDATA[ */' +
        'console.log("triggered");'+
        'var google_conversion_id = 882045750;'+
        'var google_conversion_language = "en";'+
        'var google_conversion_format = "3";'+
        'var google_conversion_color = "ffffff";'+
        'var google_conversion_label = "ud1YCOaT2mwQtubLpAM";'+
        'var google_remarketing_only = false;'+
        '/* ]]> */'+
      '</script>'+
      '<script type="text/javascript" src="//www.googleadservices.com/pagead/conversion.js"></script>'+
      '<noscript>'+
        '<div style="display:inline;">'+
          '<img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/882045750/?label=ud1YCOaT2mwQtubLpAM&amp;guid=ON&amp;script=0"/>'+
        '</div>'+
      '</noscript>'
  };
});

upstack.directive('bingScript', function () {
  return {
    restrict: 'E',
    template: '<script>' +
      '(function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"25035532"};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");' +
      '</script>'
  };
});

upstack.directive('quoraScript', function () {
  return {
    restrict: 'E',
    template: '<script>' +
      '!function(q,e,v,n,t,s){if(q.qp) return; n=q.qp=function(){n.qp?n.qp.apply(n,arguments):n.queue.push(arguments);}; n.queue=[];t=document.createElement(e);t.async=!0;t.src=v; s=document.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t,s);}(window, "script", "https://a.quora.com/qevents.js");' +
      'qp("init", "6028c6e9002d4a5aaeb35f5d654b91f4");' +
      'qp("track", "ViewContent");' +
      '</script>' +
      '<noscript><img height="1" width="1" style="display:none" src="https://q.quora.com/_/ad/6028c6e9002d4a5aaeb35f5d654b91f4/pixel?tag=ViewContent&noscript=1"/></noscript>' +
      '<script>qp("track", "GenerateLead");</script>'
  };
});

upstack.directive('asyncHide', function() {
  return {
    restrict: 'E',
    template: '<script>' +
        '(function (a, s, y, n, c, h, i, d, e) {' +
        's.className += \' \' + y;' +
        'h.start = 1 * new Date;' +
        'h.end = i = function () {' +
        's.className = s.className.replace(RegExp(\' ?\' + y), \'\')' +
        '};' +
        '(a[n] = a[n] || []).hide = h;' +
        'setTimeout(function () {' +
        'i();' +
        'h.end = null' +
        '}, c);' +
        'h.timeout = c;' +
        '})(window, document.documentElement, "async-hide", "dataLayer", 4000, {"GTM-MPKVQP4": true});' +
        '</script>'
  }
});


upstack.controller('applyCtrl', ['$scope', '$http', '$state', '$stateParams', '$window', function($scope, $http, $state, $stateParams, $window) {

  var vm = this;

  vm.params = $stateParams;

  vm.skills = [];
  vm.tabs = { parent: 1, child: 1 };
  vm.continueBtn = false;
  vm.manager = {};
  vm.selectEnabled = true;
  vm.techs = [
    { name: 'iOS Developer', value: 'ios', checked: false },
    { name: 'Android Developer', value: 'android', checked: false },
    { name: 'HTML5 Developer', value: 'html5', checked: false },
    { name: 'Angular Developer', value: 'angular', checked: false },
    { name: 'ReactJS Developer', value: 'reactjs', checked: false },
    { name: 'NodeJS Developer', value: 'nodejs', checked: false },
    { name: 'Ruby Developer', value: 'ruby', checked: false },
    { name: 'PHP Developer', value: 'php', checked: false },
    { name: 'Python Developer', value: 'python', checked: false },
    { name: 'Java Developer', value: 'java', checked: false },
    { name: 'Other', value: 'other', checked: false },
    { name: 'I\'m not sure', value: 'notsure', checked: false }
  ];
  vm.payload = {
    new_project: null,
    wanted_devs: null,
    current_engineers: null,
    project_start: null,
    project_length: null,
    skills: [],
    name: null,
    company: null,
    email: null,
    phone: '+1'
  };

  vm.setProjectType = function(value) {
    vm.payload.new_project = value;
    vm.tabs.child = 2;

    if (vm.payload.skills.length) {
      vm.continueBtn = 'child';
    }

    vm.changeRoute();
  };

  vm.setParentTab = function(tab, direction, continueBtn) {
    if (!direction) {
      vm.tabs.parent = tab;
      vm.tabs.child = 1;
    } else {
      if (direction === 'next' && vm.tabs.parent < 4) {
        vm.tabs.parent++;
        vm.tabs.child = 1;
      }
      if (direction === 'prev' && vm.tabs.parent > 1) {
        vm.tabs.parent--;
        vm.tabs.child = 1;
      }
    }
    vm.changeRoute();
    vm.continueBtn = !!continueBtn;
  };

  vm.goToParent = function(tab) {
    switch(tab) {
      case 1: {
        vm.tabs.parent = 1;
        vm.tabs.child = 1;
        vm.continueBtn = false;
        break;
      }
      case 2: {
        if (
          vm.payload.new_project !== null &&
          vm.payload.skills.length &&
          vm.payload.current_engineers && vm.payload.wanted_devs
        ) { vm.tabs.parent = 2; vm.tabs.child = 1; vm.continueBtn = false; }
        break;
      }
      case 3: {
        if (
          vm.payload.new_project !== null &&
          vm.payload.skills.length &&
          vm.payload.current_engineers && vm.payload.wanted_devs &&
          vm.payload.project_start !== null && vm.payload.project_length !== null
        ) { vm.tabs.parent = 3; vm.tabs.child = 1; vm.continueBtn = false; }
        break;
      }
      case 4: {
        if (
          vm.payload.new_project !== null &&
          vm.payload.skills.length &&
          vm.payload.current_engineers && vm.payload.wanted_devs &&
          vm.payload.project_start !== null && vm.payload.project_length !== null &&
          vm.payload.name && vm.payload.company && vm.payload.email && vm.payload.phone
        ) { vm.tabs.parent = 4; vm.tabs.child = 1; vm.continueBtn = false; }
        break;
      }
    }

    vm.changeRoute();
  };

  vm.back = function() {
    if (vm.tabs.child > 1) {
      vm.tabs.child--;
    } else if (vm.tabs.parent > 1) {
      vm.tabs.parent--;

      switch (vm.tabs.parent) {
        case 1: vm.tabs.child = 4; break;
        case 2: vm.tabs.child = 2; break;
        default: vm.tabs.child = 1;
      }
    }

    if (vm.tabs.parent === 1 && vm.tabs.child === 2) {
      if (vm.payload.skills.length) {
        vm.continueBtn = 'child';
      }
    } else {
      vm.continueBtn = false;
    }

    vm.changeRoute();
  };

  vm.setChildTab = function(direction, continueBtn) {
    if (direction) {
      vm.tabs.child++;
    } else {
      vm.tabs.child--;
    }

    vm.continueBtn = !!continueBtn;

    if (vm.tabs.parent === 1 && vm.tabs.child === 2) {
      if (vm.payload.skills.length ||
        vm.techs.some(function(tech) {
          return tech.checked && tech.value !== 'other';
        })
      ) {
        vm.continueBtn = 'child';
      }
    }

    vm.changeRoute();
  };

  vm.setNrDevelopers = function(value) {
    vm.payload.wanted_devs = value;
    vm.setChildTab(true);
  };
  vm.setNrEngineers = function(value) {
    vm.payload.current_engineers = value;
    vm.tabs.parent = 2;
    vm.tabs.child = 1;

    vm.changeRoute();
  };

  vm.getSkills = function() {
    $http.get('https://api.upstack.co/selectors/skills').then(function(response) {
      vm.skills = response.data.skills;
    }, function(error) {
      console.log(error);
    });
  };
  vm.getSkills();

  vm.continue = function() {
    vm.tabs[vm.continueBtn]++;
    vm.continueBtn = false;

    vm.changeRoute();
  };

  vm.setStartWhen = function(value) {
    vm.payload.project_start = value;
    vm.tabs.child = 2;
    vm.continueBtn = false;

    vm.changeRoute();
  };

  vm.setDeveloperTime = function(value) {
    vm.payload.project_length = value;
    vm.tabs.parent = 3;
    vm.tabs.child = 1;
    vm.continueBtn = false;

    vm.changeRoute();
  };

  vm.submitData = function() {
    vm.tabs.parent = 4;
    vm.tabs.child = 1;
    vm.continueBtn = false;

    vm.changeRoute();

    $http.post('https://api.upstack.co/company/apply', vm.payload).then(function(response) {
      vm.manager = response.data;
      vm.finalPage = true;
    }, function(error) {
      console.log(error);
    })
  };

  vm.addNewSkill = function(skill) {
    // vm.selectEnabled = false;
    // vm.skills.push(skill);
    // vm.payload.skills.push(skill);
    // vm.selectEnabled = true;
    return skill;
  };

  $scope.$watch('vm.techs', function() {
    vm.continueBtn = vm.techs.some(function(tech) {
      return tech.checked && tech.value !== 'other';
    }) && 'child';

    vm.payload.skills = vm.techs.filter(function(tech) {
      return tech.checked;
    });
  }, true);

  $scope.$watch('vm.payload.skills', function() {
    vm.continueBtn = !!vm.payload.skills.length && 'child';
  }, true);

  $scope.$watch('vm.params', function(params) {
    var query = {
      parent: +params.parent || 1,
      child: +params.child || 1
    };

    if (JSON.stringify(vm.tabs) !== JSON.stringify(query)) {
      vm.tabs.parent = query.parent;
      vm.tabs.child = query.child;

      if (vm.tabs.parent === 1 && vm.tabs.child === 2) {
        if (vm.payload.skills.length ||
          vm.techs.some(function(tech) {
            return tech.checked && tech.value !== 'other';
          })
        ) {
          vm.continueBtn = 'child';
        }
      }
    }
  }, true);

  vm.changeRoute = function() {
    $state.go('apply', {parent: vm.tabs.parent, child: vm.tabs.child}, {notify: false});

    if (vm.tabs.parent === 1 && vm.tabs.child === 1) {

    } else {
      ga('set', 'page', '/company/apply-v2/' + vm.tabs.parent + '/' + vm.tabs.child);
      ga('send', 'pageview');
    }
  };

  vm.formatPhone = function(phone) {
    if (phone) {
      var result = phone.replace('+1', '');
      result = '(' + result.substr(0, 3) + ')' + result.substr(3, 3) + '-' + result.substr(6, 4)
      return result;
    }
  };

  var input = document.querySelector("#phone");
  var iti = window.intlTelInput(input, {
    utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/15.0.0/js/utils.js',
    formatOnDisplay: true,
    geoIpLookup: function(success, failure) {
      $http.get("https://ipinfo.io", function() {}, "jsonp").then(function(resp) {
        var countryCode = (resp && resp.country) ? resp.country : "";
        success(countryCode);
      });
    }
  });

  window.intlTelInputGlobals.loadUtils("https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/15.0.0/js/utils.js");

  input.addEventListener('countrychange', function(e) {
    $scope.$apply(function() {
      var phone = e.target.value;
      vm.payload.phone = phone;
    });
  });

  input.addEventListener('change', function(e) {
    $scope.$apply(function() {
      vm.payload.phone = e.target.value;
    });
  });

  input.addEventListener('keydown', function(e) {
    $scope.$apply(function() {
      vm.payload.phone = e.target.value;
    });
  });

  // $scope.$$postDigest(function(){
  //   $scope.$apply(function() {
  //     vm.payload.phone = '+1';
  //     input.value = '+1';
  //   });
  // });

}]);
